import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import Logo from '../Cutesies/Logo';

interface Props {
  width?: string;
}

const CenteredLogo: React.FC<Props> = ({ width }) => (
  <div className={clsx('my-2 mx-auto px-8 pb-5 h-auto', width)}>
    <Logo />
  </div>
);

export default observer(CenteredLogo);
